<template>
    <div class="repay__cash-terminals">
        <div class="repay__cash-terminals__info">
            <div class="repay__cash-terminals__info-title">
                <img class="repay__cash-terminals__info-icon" src="@/assets/svg/icons/icon_2_mk.svg" alt="" />
                <p class="repay__cash-terminals__info-text">Как внести платёж наличными</p>
            </div>
        </div>
        <tabs :options="{ useUrlFragment: false }">
            <tab prefix="<span class='icon icon--m icon--qiwi'></span>" name="Qiwi терминал">
                <div class="repay__cash-terminals__screenshot">
                    <div class="repay__cash-terminals__screenshot-title">Терминал Qiwi</div>
                    <div class="repay__cash-terminals__screenshot-text">При оплате в терминалах Qiwi комиссия не взимается</div>
                    <div class="repay__cash-terminals__screenshot-step step--first">
                        <div class="repay__cash-terminals__screenshot-step-title">Шаг 1</div>
                        <img class="repay__cash-terminals__screenshot-step-image" src="@/assets/img/how-to-pay-off/ct_qt_1.png" alt="" />
                    </div>
                    <div class="repay__cash-terminals__screenshot-step step--second">
                        <div class="repay__cash-terminals__screenshot-step-title">Шаг 2</div>
                        <img class="repay__cash-terminals__screenshot-step-image" src="@/assets/img/how-to-pay-off/ct_qt_2.png" alt="" />
                    </div>
                    <div class="repay__cash-terminals__screenshot-step step--third">
                        <div class="repay__cash-terminals__screenshot-step-title">Шаг 3</div>
                        <img class="repay__cash-terminals__screenshot-step-image" src="@/assets/img/how-to-pay-off/ct_qt_3.png" alt="" />
                    </div>
                    <div class="repay__cash-terminals__screenshot-step step--fourth">
                        <div class="repay__cash-terminals__screenshot-step-title">Шаг 4</div>
                        <img class="repay__cash-terminals__screenshot-step-image" src="@/assets/img/how-to-pay-off/ct_qt_4.png" alt="" />
                    </div>
                    <div class="repay__cash-terminals__screenshot-step step--fifth">
                        <div class="repay__cash-terminals__screenshot-step-title">Шаг 5</div>
                        <img class="repay__cash-terminals__screenshot-step-image" src="@/assets/img/how-to-pay-off/ct_qt_5.png" alt="" />
                    </div>
                </div>
                <div class="repay__cash-terminals__description">
                    <div class="repay__cash-terminals__description-text">Внесите наличные и подтвердите платёж. Учтите, что терминал на выдаёт сдачу</div>
                    <div class="repay__cash-terminals__description-info">
                        <img class="repay__cash-terminals__description-info-image" src="@/assets/svg/icons/info_p.svg" alt="" />
                        <div class="repay__cash-terminals__description-info-text">Квитанцию сохраните. Она потребуется, если по какой-то причине мы не получим платёж через терминал</div>
                    </div>
                </div>
            </tab>
            <tab prefix="<span class='icon icon--m icon--kassa'></span>" name="Касса24 терминал" >
                <div class="repay__cash-terminals__screenshot">
                    <div class="repay__cash-terminals__screenshot-title">Терминал Kassa24</div>
                    <div class="repay__cash-terminals__screenshot-step step--first">
                        <div class="repay__cash-terminals__screenshot-step-title">Шаг 1</div>
                        <img class="repay__cash-terminals__screenshot-step-image" src="@/assets/img/how-to-pay-off/k24_kt_01.png" alt="" />
                    </div>
                    <div class="repay__cash-terminals__screenshot-step step--second">
                        <div class="repay__cash-terminals__screenshot-step-title">Шаг 2</div>
                        <img class="repay__cash-terminals__screenshot-step-image" src="@/assets/img/how-to-pay-off/k24_kt_02.png" alt="" />
                    </div>
                    <div class="repay__cash-terminals__screenshot-step step--third">
                        <div class="repay__cash-terminals__screenshot-step-title">Шаг 3</div>
                        <img class="repay__cash-terminals__screenshot-step-image" src="@/assets/img/how-to-pay-off/k24_kt_03.png" alt="" />
                    </div>
                    <div class="repay__cash-terminals__screenshot-step step--fourth">
                        <div class="repay__cash-terminals__screenshot-step-title">Шаг 4</div>
                        <img class="repay__cash-terminals__screenshot-step-image" src="@/assets/img/how-to-pay-off/k24_kt_04.png" alt="" />
                    </div>

                </div>
                <div class="repay__cash-terminals__description">
                    <div class="repay__cash-terminals__description-info">
                        <img class="repay__cash-terminals__description-info-image" src="@/assets/svg/icons/info_p.svg" alt="" />
                        <div class="repay__cash-terminals__description-info-text">Квитанцию сохраните. Она потребуется, если по какой-то причине мы не получим платёж через терминал</div>
                    </div>
                </div>
            </tab>
        </tabs>
    </div>
</template>

<script>
    export default{
    	name: 'RepayBankCard',
        metaInfo: {
            title: 'Как внести платёж наличными – Микро',
            meta: [
                {name: 'description', content: 'При оплате в терминалах комиссия не взимается. Внесите наличные и подтвердите платёж. Учтите, что терминал на выдаёт сдачу'}
            ],
    },
        computed: {
        },
    }
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.repay__cash-terminals {
    width: 100%;
    &__info {
        display: inline-flex;
        flex-flow: column wrap;
        align-items: flex-start;
        justify-content: flex-start;

        width: 100%;
        margin-bottom: 18px;
    }
    &__info-title {
        display: inline-flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-start;

        width: 100%;
        border-bottom: 1px solid $gray-mint;
        padding-bottom: 18px;
    }
    &__info-icon {
        width: 50px;
        height: 44px;
    }
    &__info-text {
        margin-left: 21px;
        text-align: left;
        color: $gray-dim-dark;
        font-size: 16px;
        line-height: 26px;
        font-family: $RobotoBold;
    }
    &__info-title {

    }
    &__info-description {
        text-align: left;
        color: $gray-dim-dark;
        font-size: 16px;
        line-height: 24px;
        font-family: $RobotoRegular;
    }

    &__screenshot {
        margin-bottom: 57px;
        width: 100%;
    }
    &__screenshot-title {
        margin-bottom: 13px;
        text-align: left;
        color: $gray-dim-dark;
        font-size: 16px;
        line-height: 26px;
        font-family: $RobotoBold;
    }
    &__screenshot-text {
        margin-bottom: 26px;
        text-align: left;
        color: $gray-dim-dark;
        font-size: 16px;
        line-height: 26px;
        font-family: $RobotoRegular;
    }
    &__screenshot-step {
        margin-bottom: 58px;
    }
    &__screenshot-step-title {
        display: inline-flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: flex-start;

        width: 100%;
        height: 50px;
        margin-bottom: 11px;
        padding-left: 28px;
        background: $orange-o-25;

        color: $gray-dim-dark;
        font-size: 16px;
        line-height: 26px;
        font-family: $RobotoBold;
    }
    &__screenshot-step-image {
        width: 100%;
    }

    &__description {
    }
    &__description-text {
        margin-bottom: 46px;
        text-align: left;
        color: $gray-dim-dark;
        font-size: 16px;
        line-height: 18px;
        font-family: $RobotoRegular;
    }
    &__description-info {
        width: 100%;
        padding: 18px 20px 18px 32px;
        background-color: $tooltip_background;
    }
    &__description-info-image {
        display: inline;
        float: left;
        width: 26px;
        height: 22px;
        margin-right: 8px;
    }
    &__description-info-text {
        text-align: left;
        color: $gray-dim-dark;
        font-size: 12px;
        line-height: 22px;
        font-family: $RobotoRegular;
    }
    .tabs-component {
        &-tabs {
            display: inline-flex;
            flex-flow: row nowrap;
            align-items: flex-start;
            justify-content: space-between;

            width: 100%;
            margin-bottom: 49px;
            list-style: none;
        }
        &-tab {
            width: 47%;
            &:first-child {
                width: 50%;
                padding-right: 3%;
                border-right: 1px solid $gray-mint;
            }
            &-a {
                display: inline-flex;
                flex-flow: row wrap;
                align-items: center;
                justify-content: center;

                width: 100%;
                height: 80px;

                border-bottom: 3px solid $gray-dark;
                border-radius: 12px 12px 0 0;

                color: $gray-dim;
                font-size: 18px;
                line-height: 76px;
                font-family: $RobotoBold;
                text-align: center;
                text-decoration: none;
            }
            &.is-active {
                .tabs-component-tab-a {
                    border-color: #93278F;
                    color: $gray-dim-dark;
                }
            }
            &.is-active ~ * {
            }
        }
    }
}
@media screen and (max-width: 500px) {
    .repay__cash-terminals {
        &__description-info {
            width: 100%;
        }
        .tabs-component {
            &-tab {
                &-a {
                    display: inline-flex;
                    flex-flow: column wrap;
                    align-items: center;
                    justify-content: center;

                    width: 100%;
                    height: 80px;

                    border-bottom: 3px solid $gray-dark;
                    border-radius: 12px 12px 0 0;

                    color: $gray-dim;
                    font-size: 14px;
                    line-height: 32px;
                    font-family: $RobotoRegular;
                    text-align: center;
                    text-decoration: none;
                }
            }
        }
    }
}
</style>